var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgWelloFill = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 16 16"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 15.428,
  height: 15.429,
  x: 0.572,
  y: 0.571,
  fill: "#D1D5DD",
  rx: 7.714
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F9F9F9",
  d: "m10.892 4.847-1.445 6.245h-2.04l-.484-2.687-.62 2.688h-1.92L3.176 6.65l1.984-.464.39 2.66.553-2.88 1.622-.38.595 3.302.376-3.528 2.195-.513zM13.393 5.933l-.966 3.613h-1.539l.585-4.6 1.921.987M12.3 10.82a.874.874 0 1 1-1.748 0 .874.874 0 0 1 1.748 0"
})));
export default SvgWelloFill;